/*=========================================================================================
  File Name: versionCheck.js
  Description: Verifica periodicamente si existe una nueva version de la aplicacion
               desplegada en produccion (comparando public/version.json contra la version
               cargada actualmente en el navegador). Si detecta una nueva version, recarga
               la aplicacion automaticamente sin preguntar al usuario, dejando una marca en
               localStorage para mostrar un toast informativo despues de la recarga.
========================================================================================== */

const VERSION_URL = `${process.env.BASE_URL || '/'}version.json`;
const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutos
const UPDATED_FLAG_KEY = 'app_version_updated';

let currentBuildTime = null;
let intervalId = null;

function fetchVersionInfo () {
  // Evita cache del navegador / CDN agregando un query param unico
  return fetch(`${VERSION_URL}?t=${Date.now()}`, {
    cache: 'no-store',
    headers: { 'Cache-Control': 'no-cache' }
  }).then(response => {
    if (!response.ok) throw new Error(`No se pudo obtener version.json (status ${response.status})`);
    return response.json();
  });
}

function reloadWithUpdateFlag () {
  try {
    localStorage.setItem(UPDATED_FLAG_KEY, '1');
  } catch (e) {
    // localStorage no disponible, se ignora
  }
  window.location.reload(true);
}

async function checkForNewVersion () {
  try {
    const info = await fetchVersionInfo();

    if (currentBuildTime === null) {
      // Primera carga: se toma como version base
      currentBuildTime = info.buildTime;
      return;
    }

    if (info.buildTime && info.buildTime !== currentBuildTime) {
      reloadWithUpdateFlag();
    }
  } catch (error) {
    // Si falla la verificacion (ej. sin conexion) no se interrumpe la app
    console.warn('[versionCheck] No se pudo verificar la version de la aplicacion:', error.message);
  }
}

/**
 * Inicia la verificacion periodica de nueva version en produccion.
 */
export function startVersionCheck () {
  if (process.env.NODE_ENV !== 'production') return;
  if (intervalId) return;

  checkForNewVersion();
  intervalId = setInterval(checkForNewVersion, CHECK_INTERVAL_MS);

  // Tambien se verifica cuando el usuario vuelve a la pestaña
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkForNewVersion();
  });
}

/**
 * Si la app se acaba de recargar por una actualizacion automatica, ejecuta el callback
 * (por ejemplo, para mostrar un toast) y limpia la marca en localStorage.
 * @param {Function} callback
 */
export function notifyIfJustUpdated (callback) {
  try {
    if (localStorage.getItem(UPDATED_FLAG_KEY) === '1') {
      localStorage.removeItem(UPDATED_FLAG_KEY);
      callback();
    }
  } catch (e) {
    // localStorage no disponible, se ignora
  }
}

/**
 * Obtiene la informacion de version actual (version semver + buildTime) para mostrarla,
 * por ejemplo, en el footer de la aplicacion.
 */
export function getVersionInfo () {
  return fetchVersionInfo();
}
